require("./hireCardMetallicStep4.scss");

// @ vendors
const PropTypes = require("prop-types");
const React = require("react");

// @ helpers
const { FormattedText } = require("core/i18n").i18n;
const PersonalDataHelper = require('utilities/personalDataHelper');
const { getLastNChars } = require('utilities/stringHelper');

// @constants
const {
    DEFAULT_COMMISSION,
    SECOND_STEP,
    HYPHEN
} = require('constants/index');

const HireCardMetallicStep4SummaryWithValidation = (props) => {
    const {
        immAccounts,
        immHireCardNameSelector,
        immHireCardMetallic,
        immShippingAddress,
        originCountry,
        immMetalCard,
    } = props;
    const selectedAccount = immHireCardMetallic.getIn([
        "steps",
        SECOND_STEP,
        "accountId",
    ]);
    const immAccount = immAccounts.getIn(["byId", selectedAccount]);
    const accountIban = getLastNChars(immAccount.get("iban"));
    const addressValue = immShippingAddress.get("isFetching")
        ? HYPHEN
        : PersonalDataHelper.getHireFormattedShippingAddress(
              immShippingAddress,
              originCountry
          );
    const commission = !!immMetalCard
        ? immMetalCard.get("comission")
        : DEFAULT_COMMISSION;

    return (
        <div className="hire-card-metallic-step-four__summary row">
            <div className="hire-card-metallic-step-four__info-row row">
                <div className="col-xs-6 print-label">
                    <div className="hire-card-metallic-step-four__summary-label">
                        <FormattedText value="hireCardMetallic-summarySelectedName" />
                    </div>
                    <div className="hire-card-metallic-step-four__summary-value">
                        {immHireCardNameSelector.getIn([
                            "names",
                            immHireCardNameSelector.get("selectedIndex"),
                        ])}
                    </div>
                </div>
                <div className="col-xs-6">
                    <div className="hire-card-metallic-step-four__summary-label">
                        <FormattedText value="hireCardMetallic-summarySelectedAccount" />
                    </div>
                    <div className="hire-card-metallic-step-four__summary-value">
                        <span>{immAccount.get("alias")}</span>
                        &nbsp;
                        <span>{accountIban}</span>
                    </div>
                </div>
            </div>
            <div className="hire-card-metallic-step-four__info-row row">
                <div className="col-xs-6 print-label">
                    <div className="hire-card-metallic-step-four__summary-label">
                        <FormattedText value="hireCardMetallic-summaryCommissionValue" />
                    </div>
                    <div className="hire-card-metallic-step-four__summary-value">
                        {`${commission}€`}
                    </div>
                </div>
                <div className="col-xs-6 print-label">
                    <div className="hire-card-metallic-step-four__summary-label">
                        <FormattedText value="hireCardMetallic-summaryShippingAddress" />
                    </div>
                    <div className="hire-card-metallic-step-four__summary-value">
                        {addressValue}
                    </div>
                </div>
            </div>
        </div>
    );
};

HireCardMetallicStep4SummaryWithValidation.propTypes = {
    immAccounts: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immHireCardMetallic: PropTypes.object.isRequired,
    immShippingAddress: PropTypes.object.isRequired,
    immMetalCard: PropTypes.object.isRequired,
    originCountry: PropTypes.string.isRequired,
};

module.exports = HireCardMetallicStep4SummaryWithValidation;
